module.exports = __webpack_public_path__ + "static/media/nn_quantiles.6520bd5e.png";